<template>
  <div>
    <div v-if="show">
      <v-col cols="12">
        <v-row class="justify-center my-4">
          <h3 class="primary--text">Meu Perfil</h3>
        </v-row>
        <v-row class="justify-center mb-4">
          <v-avatar size="48" color="grey">
            <img v-if="user.foto" :src="foto" :title="user.nome" />
            <img v-else src="../assets/account.svg" :title="user.nome" />
          </v-avatar>
        </v-row>
        <v-form ref="form" v-model="formValid">
          <v-row class="justify-center">
            <v-col cols="12" sm="6">
              <v-row class="justify-center ma-2">
                <div v-if="showName">
                  <v-row class="justify-center align-center ml-5 mb-4">
                    <v-btn icon  class="mr-4" color="success">
                      <v-icon small>mdi-account</v-icon>
                    </v-btn>
                    <strong>{{user.nome}}</strong>
                    <v-btn icon  class="ml-4" color="accent" @click="showName = !showName">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </v-row>
                </div>
                <div v-else>
                  <v-row class="justify-center align-center ml-5 mb-4">
                    <v-btn icon  class="mr-4" color="accent" @click="showName = !showName">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                <v-text-field
                  color="primary"
                  v-model="name"
                  :rules="ruleName"
                  label="Nome"
                ></v-text-field>
                <v-btn icon  class="ml-4" color="primary" @click="atualizar('nome')">
                  <v-icon small>mdi-content-save-outline</v-icon>
                </v-btn>
              </v-row>
              </div>
              </v-row>
              <v-row class="justify-center mx-2 mb-4">
                <div v-if="showCel">
                  <v-row class="justify-center align-center ml-5 mb-4">
                    <v-btn icon  class="mr-4" color="success">
                      <v-icon small>mdi-cellphone-check</v-icon>
                    </v-btn>
                    <strong>{{user.cel}}</strong>
                    <v-btn icon  class="ml-4" color="accent" @click="showCel = !showCel">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </v-row>
                </div>
                <div v-else>
                  <v-row class="justify-center align-center ml-5 mb-4">
                    <v-btn icon  class="mr-4" color="accent" @click="showCel = !showCel">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                <v-text-field
                  type="text"
                  v-mask="'(##) #####-####'"
                  hint="Somente números (00) 00000-0000"
                  persistent-hint
                  color="primary"
                  v-model="cel"
                  :rules="ruleCel"
                  label="Celular"
                ></v-text-field>
                <v-btn icon  class="ml-4" color="primary" @click="atualizar('cel')">
                  <v-icon small>mdi-content-save-outline</v-icon>
                </v-btn>
              </v-row>
              </div>
              </v-row>
              <v-row class="justify-center mb-4">
                <strong class="primary--text">{{ user.email }}</strong>
              </v-row>
              <v-row v-if="user.desc" class="justify-center mb-4">
                <span>Desconto especial: </span><strong class="ml-2 primary--text">{{ user.desc }}{{ " %" }}</strong>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </div>
    <div v-else>
      <v-row style="height: 80vh" class="justify-center align-center">
        <v-progress-circular
          :size="60"
          :width="8"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "cadastro-complete",
  computed: {
    user() {
      return this.$store.getters.user;
    },
    logado() {
      return this.$store.getters.logado;
    },
  },
  watch: {
    user(u) {
        this.name = u.nome;
        this.cel = u.cel;
        this.foto = u.foto || "";
    }
  },
  mounted() {
    setTimeout(() => {
      this.name = this.user.nome
      this.foto = this.user.foto
      this.cel = this.user.cel
      this.show = true;
    }, 1000);
  },
  data() {
    return {
      show: false,
      showName: true,
      showCel: true,
      disabled: true,
      loading: false,
      name: "",
      cel: "",
      foto: "",
      fazer: "",
      formValid: false,
      ruleName: [
        (value) => !!value || "Obrigatório.",
        (value) => value.length >= 10 || "Míx. 10 caracteres.",
        (value) => !!value || "Obrigatório.",
        (value) => value.length <= 30 || "Max. 30 caracteres.",
      ],
      ruleCel: [
        (value) => !!value || "Obrigatório.",
        (value) => value.length === 15 || "Celular inválido.",
      ],
    };
  },
  methods: {
    atualizar(tipo) {
      let obj = this.user;
      if (tipo === 'nome') {
        if (this.name.length <= 3) {
          this.name = obj.name
          this.showName = true
          return
        } else {
          obj.nome = this.name;
        }
      }
      if (tipo === 'cel') {
        if (this.cel.length !== 15) {
          this.cel = obj.cel
          this.showCel = true
          return
        } else {
          obj.cel = this.cel;
        }
      }
      this.$store.dispatch("updateUser", obj);
      this.showName = true
      this.showCel = true
    },
  },
};
</script>
